export const displayValueOrDash = (value?: string | null): string =>
  value?.trim() || '-'

export const resolveCreatedByForDisplay = (
  createdByDisplay: string | null | undefined,
  createdById: string | null | undefined,
  users: Array<{ id: string; name?: string | null }>
): string => {
  const fromApi = createdByDisplay?.trim()
  if (fromApi) return fromApi
  return displayValueOrDash(
    users.find(user => user.id === createdById)?.name ?? createdById
  )
}
